import { useEffect, useState, useCallback } from "react";
import { Link } from "react-router-dom";
import { Briefcase, FileText, Mail, Users, CreditCard, DollarSign, Newspaper, Quote } from "lucide-react";
import api from "@/lib/api";

export default function AdminDashboard() {
  const [stats, setStats] = useState(null);

  const load = useCallback(() => api.get("/admin/stats").then((r) => setStats(r.data)).catch(() => {}), []);
  useEffect(() => { load(); }, [load]);

  const cards = stats ? [
    { label: "Business Inquiries", value: stats.inquiries, sub: `${stats.new_inquiries} new`, icon: Briefcase, to: "/admin/inquiries" },
    { label: "Career Intakes", value: stats.intakes, sub: `${stats.new_intakes} new`, icon: FileText, to: "/admin/intakes" },
    { label: "Contact Messages", value: stats.contacts, sub: `${stats.new_contacts} new`, icon: Mail, to: "/admin/contacts" },
    { label: "Subscribers", value: stats.subscribers, sub: "newsletter", icon: Users, to: "/admin/newsletter" },
    { label: "Paid Orders", value: stats.payments, sub: "completed", icon: CreditCard, to: "/admin/payments" },
    { label: "Testimonials", value: stats.testimonials, sub: `${stats.pending_testimonials} pending`, icon: Quote, to: "/admin/testimonials" },
    { label: "Revenue", value: `$${(stats.revenue_cents / 100).toFixed(2)}`, sub: "all-time", icon: DollarSign, to: "/admin/payments" },
    { label: "Blog Posts", value: stats.blog_posts, sub: "published", icon: Newspaper, to: "/admin/blog" },
  ] : [];

  return (
    <div data-testid="admin-dashboard">
      <h1 className="font-serif text-4xl text-espresso">Dashboard</h1>
      <p className="text-espresso/60 mt-2">A snapshot of your boutique practice.</p>

      {!stats ? (
        <p className="mt-10 text-espresso/50">Loading…</p>
      ) : (
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5 mt-8">
          {cards.map((c) => (
            <Link key={c.label} to={c.to} data-testid={`stat-${c.label.toLowerCase().replace(/ /g, "-")}`} className="bg-taupe rounded-2xl p-6 hover:border-champagne border border-transparent transition-colors">
              <div className="flex items-center justify-between">
                <span className="text-sm text-espresso/60">{c.label}</span>
                <c.icon className="text-champagne" size={20} />
              </div>
              <p className="font-serif text-4xl text-espresso mt-3">{c.value}</p>
              <p className="text-xs text-espresso/50 mt-1">{c.sub}</p>
            </Link>
          ))}
        </div>
      )}

      <div className="mt-10 bg-forest grain relative overflow-hidden rounded-2xl p-8">
        <div className="relative z-10">
          <h2 className="font-serif text-2xl text-ivory">Quick actions</h2>
          <div className="flex flex-wrap gap-3 mt-5">
            <Link to="/admin/blog" className="bg-champagne text-espresso rounded-full px-5 py-2.5 text-sm font-medium hover:bg-ivory transition-colors">Write a blog post</Link>
            <Link to="/admin/pricing" className="bg-ivory/10 text-ivory border border-ivory/30 rounded-full px-5 py-2.5 text-sm font-medium hover:bg-ivory hover:text-espresso transition-colors">Edit pricing</Link>
            <Link to="/admin/settings" className="bg-ivory/10 text-ivory border border-ivory/30 rounded-full px-5 py-2.5 text-sm font-medium hover:bg-ivory hover:text-espresso transition-colors">Connect Calendly</Link>
          </div>
        </div>
      </div>
    </div>
  );
}
